import React from 'react';

export type Support = {
  isIOS: boolean;
  isAndroid: boolean;
  touch: boolean;
  chromecast: boolean;
  airplay: boolean;
  subtitles: boolean;
  fullscreen: boolean;
  pip: boolean;
};

function useSupport(): Support {
  const [supported] = React.useState<Support>({
    isIOS: /iPad|iPhone|iPod/.test(navigator.platform),
    isAndroid: /Android/.test(navigator.userAgent),
    touch: 'ontouchstart' in document.documentElement,
    chromecast: (
      (!!(window as any).chrome?.cast?.isAvailable) ||
      (!!(navigator as any).presentation?.receiver)
    ),
    airplay: !!(window as any)?.WebKitPlaybackTargetAvailabilityEvent,
    subtitles: 'textTracks' in document.createElement('video'),
    fullscreen: !!(
      'fullscreenEnabled' in document ||
      'webkitFullscreenEnabled' in document ||
      'mozFullScreenEnabled' in document ||
      'msFullscreenEnabled' in document
    ),
    pip: !!(document.pictureInPictureEnabled),
  });

  return supported;
}

export default useSupport;
